<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('cancellation')"></TitlePage>

    <v-form @submit.prevent="update()" class="bb-gray pb-5" ref="form_create" v-model="check">
      <v-layout wrap>

        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Prenotazione</td>
                  <td><a :href="`/#/bookings/edit/${item.booking_id}`" target="_blank">Vedi Dettagli</a></td>
                </tr>
                <tr>
                  <td>Utente</td>
                  <td><a :href="`/#/customers/edit/${item.user_id}`" target="_blank" v-if="item.user_id != null">Vedi Dettagli</a></td>
                </tr>
                <tr>
                  <td>Tipo di Rimborso</td>
                  <td>{{getTypeCancellation(item.refund.type)}}</td>
                </tr>
                <tr>
                  <td>Importo Rimborsato</td>
                  <td>{{item.refund.value.toFixed(2)}} €</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>
                    <v-chip small :color="getStatus(item.status, 'color')">{{ getStatus(item.status, 'name') }}</v-chip>
                    <template v-if="item.status == 'pending'"><v-btn color="success" small @click="update" class="ml-2"><v-icon>mdi-calendar-check-outline</v-icon>Segna come completato</v-btn></template>
                  </td>
                </tr>
                <tr>
                  <td>Motivo</td>
                  <td>{{item.reason}}</td>
                </tr>
                <tr>
                  <td>Ore di Anticipo alla prenotazione</td>
                  <td>{{item.hours_before}} ore</td>
                </tr>
                <tr>
                  <td>Promo Code associato al rimborso</td>
                  <td>{{item.promo_code_refund}}</td>
                </tr>
                <tr>
                  <td>Data rimborso</td>
                  <td>{{new Date(item.refunded_at).toLocaleString()}}</td>
                </tr>
                <tr>
                  <td>Data creazione</td>
                  <td>{{new Date(item.created_at).toLocaleString()}}</td>
                </tr>
                <tr>
                  <td>Data ultimo aggiornamento</td>
                  <td>{{new Date(item.updated_at).toLocaleString()}}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>


        <v-flex md12 class="pt-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>

        <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
          <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            {{ $t('back') }}
          </v-btn>
        </v-flex>

      </v-layout>

    </v-form>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "EditCancellation",
  components: {TitlePage},
  data() {
    return {
      item: {
        status: false,
      },
      promotion_types: [
        {'text': '', 'value': null},
        {'text': this.$t('fixed'), 'value': 'fixed'},
        {'text': this.$t('percentage'), 'value': 'percentage'},
      ],
      check: true,
      rules: {
        required: value => !!value || this.$t('fillMandatory'),
        number_gt_zero: v => v > 0 || this.$t('fillMandatory'),
      },
    };
  },
  async created(){
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)
    this.item = this._.clone(fetchItem.result)
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem': 'cancellations/edit',
      'updateItem': 'cancellations/update'
    }),
    async update(){

      this.item.status = 'completed'

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },
    getStatus(status, type) {

      if (status == 'completed') {
        return (type == 'name') ? 'Completato' : 'success'
      }else if (status == 'pending') {
        return (type == 'name') ? 'In attesa' : 'primary'
      }

    },
    getTypeCancellation(type){
      if(type == 'nothing'){
        return 'Nessuno'
      }else if( type == 'fixed'){
        return 'Importo Fisso'
      }else if( type == 'promo_code'){
        return 'Promo Code'
      }
    },

    getSlot(date, slot_id) {
      var string_date = new Date(date).toLocaleDateString()
      var split = slot_id.split(';')
      string_date += ' | ' + split[3] + ' - ' + split[4]
      return string_date
    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>